/** As peças das telas de entrada que mudam com o hub: o hero, o logo e o rodapé.
 *
 *  Os dois hubs ficam montados um sobre o outro e só o escolhido aparece. A troca
 *  pelo seletor vira um fundido, sem esperar foto carregar; o `login.css` cuida do
 *  tempo e da ordem das camadas. */
import { Fragment } from 'react'
import { HUBS, type HubKey } from '@/core/hubs/hubs'
import { useI18n } from '@/core/i18n/useI18n'
import { PELES, type MarcaDoHero } from './peles'

export function HeroDoHub({ hub }: { hub: HubKey }) {
  const { t } = useI18n()
  return (
    <section className="login-hero">
      {HUBS.map(({ key }) => {
        const ativo = key === hub
        const pele = PELES[key]
        return (
          <div key={key} className="login-hero-camada" data-hub={key} aria-hidden={!ativo}>
            <img className="login-hero-photo" src={pele.heroFoto} alt={ativo ? t(pele.heroAltKey) : ''} />
            <MarcasDoHero marcas={pele.marcasDoHero} ativo={ativo} />
          </div>
        )
      })}
    </section>
  )
}

/** As marcas da empresa em branco no canto do hero, com um fio entre elas. */
function MarcasDoHero({ marcas, ativo }: { marcas: MarcaDoHero[]; ativo: boolean }) {
  return (
    <div className="login-hero-marcas">
      {marcas.map((marca, indice) => (
        <Fragment key={marca.src}>
          {indice > 0 && <span className="login-hero-marcas-divisor" aria-hidden="true" />}
          <img className={marca.classe} src={marca.src} alt={ativo ? marca.alt : ''} />
        </Fragment>
      ))}
    </div>
  )
}

export function MarcaDoHub({ hub }: { hub: HubKey }) {
  return (
    <header className="login-brand">
      {HUBS.map(({ key, nome }) => {
        const ativo = key === hub
        const pele = PELES[key]
        return (
          <span key={key} className="login-marca" data-hub={key} aria-hidden={!ativo}>
            <img className="login-marca-claro" src={pele.logo} alt={ativo ? nome : ''} />
            {pele.logoEscuro && <img className="login-marca-escuro" src={pele.logoEscuro} alt={ativo ? nome : ''} />}
          </span>
        )
      })}
    </header>
  )
}

export function RodapeDoHub({ hub }: { hub: HubKey }) {
  const { t } = useI18n()
  return (
    <footer className="login-foot">
      <span>© 2026 {PELES[hub].empresa}</span>
      <a
        className="login-powered"
        href="https://ordinum.com.br"
        target="_blank"
        rel="noopener"
        aria-label={t('auth.loginPage.poweredByAria', { brand: 'Ordinum' })}
      >
        <span className="login-powered-pre">{t('auth.loginPage.poweredBy')}</span>
        <span className="login-ordinum-logo" aria-hidden="true" />
        <span className="login-powered-name">Ordinum</span>
      </a>
    </footer>
  )
}
